import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { LINKS } from '../config/links';
import { colors, shared } from '../styles/theme';

function Contact() {
  return (
    <section className={css(styles.page)}>
      <p className={css(styles.eyebrow)}>Contact</p>
      <h1 className={css(styles.title)}>Speak to the YaBatho team.</h1>
      <p className={css(styles.copy)}>
        Use the right contact channel for customer access, restaurant
        onboarding, rider access, platform support, or business partnerships.
      </p>

      <div className={css(styles.grid)}>
        {[
          ['Admin / Business', LINKS.adminEmail],
          ['Support', LINKS.supportEmail],
          ['Partnerships', LINKS.partnershipsEmail],
        ].map(([label, email]) => (
          <a className={css(styles.card)} href={`mailto:${email}`} key={email}>
            <span className={css(styles.label)}>{label}</span>
            <strong className={css(styles.email)}>{email}</strong>
          </a>
        ))}
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  page: {
    ...shared.navPage,
  },
  eyebrow: shared.eyebrow,
  title: {
    margin: '0 0 18px',
    color: colors.ink,
    fontSize: '3.2rem',
    fontWeight: '900',
    lineHeight: 1.05,
    '@media (max-width: 520px)': {
      fontSize: '2rem',
      lineHeight: 1.08,
    },
  },
  copy: {
    margin: '0 0 34px',
    color: colors.muted,
    fontSize: '1.06rem',
    lineHeight: 1.8,
    maxWidth: '820px',
    '@media (max-width: 520px)': {
      fontSize: '0.98rem',
      lineHeight: 1.65,
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '16px',

    '@media (max-width: 760px)': {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    padding: '24px',
    textDecoration: 'none',
    boxShadow: '0 10px 28px rgba(30, 30, 30, 0.05)',
  },
  label: {
    display: 'block',
    color: colors.gold,
    fontSize: '0.78rem',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '10px',
  },
  email: {
    color: colors.ink,
    fontSize: '1rem',
    wordBreak: 'break-word',
  },
});

export default Contact;
